<template>
  <div class="coding">
    <!-- <h1>开发中....</h1> -->
    <div>
      <img :src="img" alt=""/>
    </div>

    <div class="coding-content">
      <span class="coding-title">开发中...</span>
      <span class="coding-info">抱歉，该页面功能我们的工程师正在开发中</span>  
    </div> 
    
  </div>
</template>

<script>
export default {
  
  name: 'Coding',
  data() {
    return {
        img: require('../../assets/img/coding.png')
    };
  },
  created() {
  },
  watch: {},
  mounted() {
  },
  components: {
  },
  computed: {
  },
  methods: {
  },
};
</script>
<style lang='scss'>
.coding{
  background:#fff;
  padding: 74px 265px;
  margin-top: 20px;
  font-family: 'PingFangSC-Regular, PingFang SC'; 
  display: flex; 
  flex-direction: row;
    flex-wrap: nowrap;
  align-content: center;
  height: calc(100vh - 400px);
  min-width: 1080px;
  img{
    width: 440px;
    height: 514px;
  }
  .coding-content{
    display: flex; 
    flex-direction: column;
    justify-content: center;
    // margin-left: 120px;
    // margin-top: -100px;
    .coding-title{
      font-size: 56px;
      line-height: 32px;
      color: #000000;
    }
    .coding-info{
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 14px;
      margin-top: 32px;
    }
  }
}
</style>
